module.exports = __webpack_public_path__ + "static/media/microbit-skate.02ed15ea.png";